import { defineStore } from "pinia";
import ApiRequest from "@/common/axios";

const URL_RESET_PASSWORD = "api/reset-password"
const apiPostReset = (id, payload) => ApiRequest.post(URL_RESET_PASSWORD + "/" + id, payload);

export const useResetPasswordStore = defineStore("resetPassword", {
    state: () => ({
        success: "",
        message: "",
        line_id: "",
    }),
    getters: {
        getResult: (state) => {
            return state.success;
        },
        getMessage: (state) => {
            return state.message;
        },
        getLineId: (state) => {
            return state.line_id;
        }
    },
    actions: {
        async checkURL(id, payload) {
            return apiPostReset(id, payload).then((res) => {
                const { success, message } = res.data;
                this.success = success;
                this.message = message;
                if (success) {
                    this.line_id = res.data.data;
                }
            })
            .catch((err) => {
                console.log(err);
                this.setFailure("URLの検証に失敗しました。")
            })
        },
        async resetPassword(id, payload) {
            return apiPostReset(id, payload).then((res) => {
                const { success, message } = res.data;
                this.success = success;
                this.message = message;
            })
            .catch((err) => {
                console.log(err);
                this.setFailure("パスワードの再設定に失敗しました。")
            }
            );
        },
        resetResult() {
            this.success = "";
            this.message = "";
        },
        setFailure(message) {
            this.success = false;
            this.message = message;
        }
    },
});
